export default __webpack_public_path__ + "static/media/banner_2.6000d7bd.jpg";